<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="寝室名称" prop="dormitoryName">
        <el-input v-model="dataForm.dormitoryName" placeholder="宿舍名称"></el-input>
      </el-form-item>
      <el-form-item label="楼层名称" prop="dormBuildingName">
        <el-select v-model="dataForm.dormBuildingId" placeholder="请选择">
          <el-option v-for="building in dormBuildingList"
                     :label="building.title"
                     :key="building.id"
                     :value="building.id"></el-option>
        </el-select>
      </el-form-item>
     <!-- <el-form-item label="楼层" prop="floor">
        <el-select v-model="dataForm.floor" >
          <el-option v-for="floor in  floorList" :key="floor" :label="floor+'楼'" :value="floor"></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="性别" prop="dormitorySex">
        <el-radio-group  v-model="dataForm.dormitorySex">
          <el-radio :label="sexual.WOMAN">女</el-radio>
          <el-radio :label="sexual.MAN">男</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="宿舍学生" prop="clubTeachTeacher">
        <span style="padding-right:10px;" :key="g" v-for="g in this.studentNameList">{{g}}</span>
        <el-button style="color: #0aa0bf" @click="getStudentList()">+添加学生</el-button>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
    <dormitory-student-add v-if="studentListVisible" ref="dormitoryStudentAdd" v-on:checkedStudents="checkedStudents"></dormitory-student-add>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import DormitoryStudentAdd from './dormitory-student-add'
import { sexual } from '@/constant'

export default {
  components: { DormitoryStudentAdd },
  data () {
    return {
      visible: false,
      sexual,
      studentListVisible: false,
      studentNameList: [],
      dormBuildingList: [],
      floorList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50],
      dataForm: {
        id: '',
        dormitoryName: '',
        floor: '',
        dormitorySex: '',
        createDate: '',
        updateDate: '',
        creator: '',
        deptId: '',
        studentList: [],
        studentNameList: [],
        schoolId: '',
        dormBuildingName: '',
        dormBuildingId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.getDormBuildingList()
        this.$refs.dataForm.resetFields()
        this.studentNameList = []
        this.dataForm.studentList = []
        console.log(this.dataForm.studentList)
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    checkedStudents (val) {
      this.dataForm.studentList = val[0]
      this.studentNameList = val[1]
    },
    // 获取学生列表
    getStudentList () {
      this.studentListVisible = true
      this.$nextTick(() => {
        this.$refs.dormitoryStudentAdd.init(this.dataForm.studentList, this.studentNameList)
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/dormitory/dormitory/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.studentNameList = this.dataForm.studentNameList
      }).catch(() => {})
    },
    // 获取宿舍楼集合
    getDormBuildingList () {
      this.$http.get('dormBuilding/dormBuilding/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dormBuildingList = res.data
        console.log(res.data)
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.dormBuildingName = this.dormBuildingList.filter((e) => { return e.id === this.dataForm.dormBuildingId })[0].title
        this.$http.post('/dormitory/dormitory/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
